
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/materials/[post]",
      function () {
        return require("private-next-pages/materials/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/materials/[post]"])
      });
    }
  